export default {"src":"/_next/static/media/broken-link.3c6f4bfc.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};